import React from "react";
import Dashboard from "./Dashboard";
import Home from "./Home";

const Login_Dash = () => {
  return (
    <>
      <Dashboard />
      <Home />
    </>
  );
};

export default Login_Dash;
